// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 2937 ? "eabe11fc" : chunkId) + "." + {"246":"758f3b9049c96309","2937":"e4ecc13838fc5435","8361":"548f6760a31dec2d"}[chunkId] + ".js";
};